import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom'
import Button from '../ui/Button';
import Input from '../ui/Input';
import Select from '../ui/Select';
import TextArea from '../ui/TextArea';
import { UnitData } from '../../data/UnitData'
import { createItem } from '../../services/api';
import { toast } from 'react-toastify';

function AddItemModal({ onClose, onAdd, itemGroups }) {
  const [newItem, setNewItem] = useState({
    serialNumber: '',
    name: '',
    altname: '',
    quantity: '',
    price: '',
    costPrice: '',
    lowStockThreshold: '',
    group: 'Raw Material',
    unitType: 'pcs',
    description: '',
    department: '',
    category: '',
    image: ''
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const navigate = useNavigate();

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   onAdd({
  //     ...newItem,
  //     quantity: parseInt(newItem.quantity),
  //     price: parseFloat(newItem.price),
  //     costPrice: parseFloat(newItem.costPrice),
  //     lowStockThreshold: parseInt(newItem.lowStockThreshold),
  //     lastModified: new Date().toISOString()
  //   });
  //   onClose();
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    try {
        const response = await createItem(newItem);
        setSuccess('Item created successfully!');
        // console.log('Issue registered:', response);
        toast.success('Item created successfully!');
        onClose();
        // navigate('/inventory'); // Redirect to the issues list page
    } catch (err) {
        setError(err.message || 'Failed to create Item');
        toast.error(err.message || 'Failed to create Item');
    }
  };


  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center overflow-auto z-[9999]">
      <div className="bg-white p-6 rounded-lg max-w-2xl w-full max-h-screen overflow-auto">
        <h2 className="text-xl font-bold mb-4">Add New Item</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label htmlFor="name" className="block text-sm font-medium text-gray-700">Name <span className='text-red-500'>*</span></label>
              <Input
                id="name"
                value={newItem.name}
                onChange={(e) => setNewItem({ ...newItem, name: e.target.value.toLowerCase() })}
                required
              />
            </div>
            <div>
              <label htmlFor="altname" className="block text-sm font-medium text-gray-700">Alternate Name</label>
              <Input
                id="altname"
                value={newItem.altname}
                onChange={(e) => setNewItem({ ...newItem, altname: e.target.value })}
                // required
              />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label htmlFor="quantity" className="block text-sm font-medium text-gray-700">Quantity <span className='text-red-500'>*</span></label>
              <Input
                id="quantity"
                type="number"
                value={newItem.quantity}
                onChange={(e) => setNewItem({ ...newItem, quantity: e.target.value })}
                required
              />
            </div>
            <div>
              <label htmlFor="unitType" className="block text-sm font-medium text-gray-700">Unit Type</label>
              {/* <Input
                id="unitType"
                value={newItem.unitType}
                onChange={(e) => setNewItem({ ...newItem, unitType: e.target.value })}
                placeholder="e.g., pcs, kg, liters"
                required
              /> */}
              <Select
                id="unitType"
                value={newItem.unitType}
                onChange={(e) => setNewItem({ ...newItem, unitType: e.target.value })}
                // required
              >
                <option value="">Select unit</option>
                {UnitData.map((unit) => (
                  <option key={unit.id} value={unit.name}>
                    {unit.name}
                  </option>
                ))}
              </Select>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label htmlFor="lowStockThreshold" className="block text-sm font-medium text-gray-700">Low Stock Threshold <span className='text-red-500'>*</span></label>
              <Input
                id="lowStockThreshold"
                type="number"
                value={newItem.lowStockThreshold}
                onChange={(e) => setNewItem({ ...newItem, lowStockThreshold: e.target.value })}
                required
              />
            </div>
            <div>
              <label htmlFor="group" className="block text-sm font-medium text-gray-700">Group <span className='text-red-500'>*</span></label>
              <Select
                id="group"
                value={newItem.group}
                onChange={(e) => setNewItem({ ...newItem, group: e.target.value })}
                required
              >
                <option value="">Select a group</option>
                {itemGroups.map((group) => (
                  <option key={group.id} value={group.name}>
                    {group.name}
                  </option>
                ))}
              </Select>
            </div>
          </div>
          {/* <div className="grid grid-cols-2 gap-4">
            <div>
              <label htmlFor="price" className="block text-sm font-medium text-gray-700">Selling Price (per unit)</label>
              <Input
                id="price"
                type="number"
                step="0.01"
                value={newItem.price}
                onChange={(e) => setNewItem({ ...newItem, price: e.target.value })}
                placeholder="in Rupees(₹)"
              />
            </div>
            <div>
              <label htmlFor="costPrice" className="block text-sm font-medium text-gray-700">Cost Price (per unit)</label>
              <Input
                id="costPrice"
                type="number"
                step="0.01"
                value={newItem.costPrice}
                onChange={(e) => setNewItem({ ...newItem, costPrice: e.target.value })}
                placeholder="in Rupees(₹)"
              />
            </div>
          </div> */}

          <div>
            <label htmlFor="description" className="block text-sm font-medium text-gray-700">Description</label>
            <TextArea
              id="description"
              value={newItem.description}
              onChange={(e) => setNewItem({ ...newItem, description: e.target.value })}
              rows={3}
            />
          </div>
          {/* <div>
            <label htmlFor="image" className="block text-sm font-medium text-gray-700">Image URL</label>
            <Input
              id="image"
              type="url"
              value={newItem.image}
              onChange={(e) => setNewItem({ ...newItem, image: e.target.value })}
              placeholder="https://example.com/image.jpg"
            />
          </div> */}
          <div className="flex justify-end space-x-2">
            <Button type="button" onClick={onClose} variant="outline">Cancel</Button>
            <Button type="submit">Add Item</Button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddItemModal;